// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_qgG","cls2":"SimplePaperPodcast-cls2_yaW SimplePaperPodcast-cls1_qgG"};